import CombinedLineChart from './CombinedLineChart';

export default CombinedLineChart;
